import React from "react";
import UncontrolledLottie from './UncontrolledLottie';
import MainMenu from "./Mainmenu";

export default () => (
    <header className="site--header container">
      <UncontrolledLottie />
      <MainMenu />
    </header>
)